import {sendEvent} from '@github-ui/hydro-analytics'
import {Link} from '@primer/react'
import {clsx} from 'clsx'

import {copilotFeatureFlags} from '../utils/copilot-feature-flags'
import {useChatState} from '../utils/CopilotChatContext'
import classes from './LegalDisclaimer.module.css'

export const LegalDisclaimer = () => {
  const {mode} = useChatState()

  return (
    <p
      className={clsx({
        [classes.legalTextImmersive]: mode === 'immersive',
        [classes.legalTextAssistive]: mode !== 'immersive',
        [classes.legalSharedTopicIndicator]: copilotFeatureFlags.sharedTopicIndicator,
      })}
    >
      <Link
        href="https://docs.github.com/en/copilot/responsible-use-of-github-copilot-features/responsible-use-of-github-copilot-chat-in-githubcom"
        inline
        muted
        sx={{
          textDecoration: 'none',
        }}
        onClick={() =>
          sendEvent('dotcom_chat.activate', {
            target: 'EMPTY_STATE_LEGAL_LINK',
            mode,
          })
        }
      >
        Copilot
      </Link>{' '}
      uses AI. Check for mistakes.
    </p>
  )
}

try{ LegalDisclaimer.displayName ||= 'LegalDisclaimer' } catch {}